const api = '/api/v1/u009_p_w_auction_controller.php';
import axios from 'axios';
export const w_auction_repository =  {
    get(parentId){
        return  axios.get(`${api}?PARENT_ID=${parentId}`);
    },
    upd(data){
        return  axios.post(api, data);
    }
};

